export default __webpack_public_path__ + "static/media/ArrowLeftIcon.739e3889.svg";